// Images hébergées dans les Ressources Impultienda de la boutique SYSTÈME ÉNERGÉTIQUE TAROT · REIKI · CHAKRAS™ (T-R-C FR).
const R = 'https://sb.impultienda.ar/storage/v1/object/public/store-resources/ee49a072-51e5-4783-b831-8bbc7e4d6894/'

export const CHECKOUT_URL = 'https://boutique-energetique.eurekalabs.store/checkout'

export const images = {
  // Mockup livre + 5 fiches en éventail, fond transparent (style du mockup validé par le propriétaire).
  mockup: R + '1793727183085_carta-mockup-f7b71d38.webp',
  // Scènes 2048×1360 : livre illustré + livre ouvert sur une table (même ligne que la page Reiki FR).
  volumes: [
    R + '1793730730499_carta-vol-1-scene-8c46879a.webp',
    R + '1793730736868_carta-vol-2-scene-f6bc52bb.webp',
    R + '1793730743078_carta-vol-3-scene-d121c44a.webp',
    R + '1793730749063_carta-vol-4-scene-460e1f57.webp',
    R + '1793730754688_carta-vol-5-scene-358424d6.webp',
    R + '1793730761103_carta-vol-6-scene-8ec87b59.webp',
  ],
  volumePages: [
    { src: R + '1793727221716_carta-vol1-p07-b2a9ed0b.webp', alt: 'Volume 1 : trois pratiques en un coup d’œil' },
    { src: R + '1793727226990_carta-vol1-p13-c64e7cfa.webp', alt: 'Volume 1 : votre premier tirage en 3 cartes' },
    { src: R + '1793727232512_carta-vol1-p19-8883a767.webp', alt: 'Volume 1 : la pratique sur soi en 12 positions' },
    { src: R + '1793727238300_carta-vol1-p28-33281372.webp', alt: 'Volume 1 : la séance intégrée en 75 minutes' },
  ],
  printables: [
    { src: R + '1793727147244_carta-fiche-09-18931ae0.webp', label: '#09 · Les arcanes majeurs, I à XI' },
    { src: R + '1793727153005_carta-fiche-17-5f580631.webp', label: '#17 · Le tirage en 3 cartes' },
    { src: R + '1793727158463_carta-fiche-25-e961a9dc.webp', label: '#25 · Carte de la pratique sur soi' },
    { src: R + '1793727163754_carta-fiche-33-fa2c92bc.webp', label: '#33 · Les 7 chakras selon la tradition' },
    { src: R + '1793727169028_carta-fiche-46-6620427a.webp', label: '#46 · Planche oui · non · peut-être' },
    { src: R + '1793727174834_carta-fiche-51-811b4744.webp', label: '#51 · La séance intégrée, 75 minutes' },
  ],
  // Cartes bonus 1600×1280 : scène + bandeau titre, 4 icônes et 15 € → 0 € (même modèle que Reiki FR).
  bonuses: [
    R + '1793730701506_carta-bonus-1-scene-8211e170.webp',
    R + '1793730707218_carta-bonus-2-scene-6df1f069.webp',
    R + '1793730713069_carta-bonus-3-scene-9b8c677f.webp',
    R + '1793730718122_carta-bonus-4-scene-5301c3d2.webp',
    R + '1793730724283_carta-bonus-5-scene-19684bc5.webp',
  ],
}
